import { Tab, Tabs, useMediaQuery, useTheme } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import EmbossedCard from './EmbossedCard';
import { Specialization } from './gw2components';

const useStyles = makeStyles()((theme) => ({
  hidden: {
    display: 'none',
  },
  tabLabelIcon: {
    minHeight: 'initial',
    minWidth: 'initial',
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  },
  outlinedContent: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
  },
  content: {},
}));

interface EmbossedTabsProps {
  panes: {
    title: string;
    specialization: string;
    content: React.ReactNode;
  }[];
  TabsProps?: React.ComponentProps<typeof Tabs>;
  CardProps?: React.ComponentProps<typeof EmbossedCard>;
}

function EmbossedTabs({ panes, TabsProps, CardProps }: EmbossedTabsProps) {
  const { classes } = useStyles();
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down('sm'));

  const [value, setValue] = React.useState(0);

  return (
    <EmbossedCard
      specialization={panes[value].specialization}
      isTabs
      title={
        <Tabs
          value={value}
          onChange={(_, changedValue) => setValue(changedValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
          {...TabsProps}
        >
          {panes.map(({ specialization, title }) => (
            <Tab
              key={title || specialization}
              {...(specialization
                ? {
                    icon: (
                      <Specialization
                        // @ts-ignore
                        name={specialization}
                        size="medium"
                        disableText
                      />
                    ),
                    ...(!small || panes.length <= 2
                      ? { label: title || specialization }
                      : {}),
                  }
                : {
                    label: title,
                  })}
              classes={{ labelIcon: classes.tabLabelIcon }}
            />
          ))}
        </Tabs>
      }
      {...CardProps}
    >
      {panes.map(({ specialization, title, content }, index) => (
        <div
          key={`content-${title || specialization}`}
          className={classNames(classes.content, {
            [classes.hidden]: index !== value,
          })}
        >
          {content}
        </div>
      ))}
    </EmbossedCard>
  );
}

export default EmbossedTabs;
